import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { Icon } from "@iconify/react";
import { useQuery } from "react-query";
import { fetchCustomersAndProfiles } from "../../../api";
import { checkForAPISuccess, showErrorToast } from "../../../Common/commonFunctions";
import { Button } from "react-bootstrap";
import { Link } from 'react-router-dom';

const EquipmentBreadcrumb = props => {

    const CUSTOMER_PLACEHOLDER = "Choose Customer", PROFILE_PLACEHOLDER = "Choose Profile";

    const [utils, setUtils] = useState({
        initial: { customer: "", profile: "", profileId: "" },
        current: { customer: "", profile: "", profileId: "" },
        profilesByCustomers: {},
        isEditActive: false,
        customerId: ""
    });
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }

    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);
    const profileId = window.location.pathname.split("/")[3];

    const fetchCustomersAndProfilesQuery = useQuery({
        queryKey: "fetch-customers-profiles",
        queryFn: async () => await fetchCustomersAndProfiles(),
        ...useQueryConfiguration
    });

    useEffect(() => {
        fetchCustomersAndProfilesQuery.refetch();
    }, []);

    useEffect(() => {
        if(fetchCustomersAndProfilesQuery.isFetched) {
            if(checkForAPISuccess(fetchCustomersAndProfilesQuery.data?.data?.statusCode)) {
                const response = fetchCustomersAndProfilesQuery.data.data.data;
                if(!_.isEmpty(response)) {
                    setCurrentCustomerAndProfile(response);
                }
            }
            else {
                showErrorToast('Failed to fetch customer and profile list');
            }
            fetchCustomersAndProfilesQuery.remove();
        }
    }, [fetchCustomersAndProfilesQuery.isFetched]);

    const setCurrentCustomerAndProfile = (profileObj) => {
        let customerObj = {}, customerName = "", currentCustomer = "", currentProfile = "", currentCustomerId;
        profileObj.forEach((profile) => {

            customerName = profile.customerName;

            if(profileId === profile.profileId) {
                currentCustomerId = profile.customerId;
                currentCustomer = _.cloneDeep(customerName);
                currentProfile = _.cloneDeep(profile.name);
            }

            if(!_.isEmpty(customerObj?.[customerName])) {
                let updatedProfilesList = customerObj[customerName];
                updatedProfilesList.push(profile);
                customerObj[customerName] = _.cloneDeep(updatedProfilesList);
            }
            else {
                customerObj[customerName] = [];
                customerObj[customerName].push(profile);
            }
        });
        setUtils({
            initial: { customer: currentCustomer, profile: currentProfile, profileId: profileId },
            current: { customer: currentCustomer, profile: currentProfile, profileId: profileId },
            profilesByCustomers: customerObj,
            customerId: currentCustomerId
        });
    }

    const handleCustomerAndProfileChange = (target, value) => {
        if(target === "customer" && value !== CUSTOMER_PLACEHOLDER) {
            setUtils({ ...utils, current: { profile: PROFILE_PLACEHOLDER, customer: value } });
        }
        else if(target === "profile" && value !== PROFILE_PLACEHOLDER) {
            const currentProfileId = utils.profilesByCustomers[utils.current.customer].filter(profile => profile.name === value)?.[0]?.profileId;
            setUtils({ ...utils, current: { ...utils.current, profile: value , profileId: currentProfileId} });
        }
    }

    return (
        !_.isEmpty(utils.profilesByCustomers) &&
            <div className="header-container">
                <div className="equipment-breadcrumb-container">
                    {
                        utils.isEditActive ?
                            <select value={utils.current.customer} className="edit-breadcrumb"
                                onChange={(e) => handleCustomerAndProfileChange("customer", e.target.value)} 
                            >
                                {
                                    Object.keys(utils.profilesByCustomers).map((customerName) => <option>{customerName}</option>)
                                }
                            </select>
                                :
                            <div className="vertical-center-align">
                                <Link className="vertical-center-align" to={{ pathname: "/" }}>
                                    <Icon className="m-0" icon="feather-home" width={20} height={20} color="gray" />
                                </Link>
                                <span className="mx-2">&gt;</span>
                                <Link to={{ pathname: `/customer/${utils.customerId}` }}>
                                    <span className="text-color-grey font-weight-bold">
                                        {utils.current.customer}
                                    </span>
                                </Link>
                            </div>
                    }
                    <span className="p-1 mx-2">
                        &gt;
                    </span>
                    {
                        utils.isEditActive ?
                            <select value={utils.current.profile} className="edit-breadcrumb"
                                onChange={(e) => handleCustomerAndProfileChange("profile", e.target.value)}
                            >
                                <option>{PROFILE_PLACEHOLDER}</option>
                                {
                                    !_.isEmpty(utils.profilesByCustomers) && !_.isEmpty(utils.profilesByCustomers[utils.current.customer]) &&
                                        utils.profilesByCustomers[utils.current.customer].map(
                                            profile => <option id={profile.profileId}>{profile.name}</option>
                                        )
                                }
                            </select>
                                :
                            <span className="text-color-grey font-weight-bold">
                                {utils.current.profile}
                            </span>
                    }
                    {
                        utils.isEditActive ?
                            <>
                                <span className="ml-2 cursor-pointer">
                                    <Icon color="gray" onClick={() => setUtils({ ...utils, isEditActive: false, current: _.cloneDeep(utils.initial) })} width={18} className="mb-1" icon={"feather-x"} />
                                </span>
                                {
                                    !_.isEmpty(utils.current.customer) && !_.isEmpty(utils.current.profile) && !_.isEqual(utils.current, utils.initial) && 
                                    utils.current.customer !== CUSTOMER_PLACEHOLDER && utils.current.profile !== PROFILE_PLACEHOLDER &&
                                        <span className="ml-2 cursor-pointer">
                                            <Icon color="#075978" width={18} onClick={() => props.reloadPage(utils.current.profileId)} className="mb-1" icon={"feather-check"} />
                                        </span>
                                }
                            </>
                                :
                            <>
                                <span className="ml-2">
                                    <Icon
                                        onClick={() => setUtils({ ...utils, isEditActive: true })}
                                        width={18} className={`mb-1 cursor-pointer ${ isEditOngoing && "text-color-grey disable-click" }`} icon={"feather-edit"}
                                    />
                                </span>
                            </>
                    }
                </div>
                <div>
                    <Link
                    to={{ pathname: `/profile/sensor/${profileId}` }}>
                        <Button size="sm">View all sensors</Button>
                    </Link>
                    <Link to={{ pathname: `/profile/bearing/${profileId}` }}>
                        <Button size="sm">View all bearings</Button>
                    </Link>
                </div>
            </div>
    )

}

export default EquipmentBreadcrumb;